import { render } from "./SkillRow.vue?vue&type=template&id=b8e05ebc"
import script from "./SkillRow.vue?vue&type=script&lang=js"
export * from "./SkillRow.vue?vue&type=script&lang=js"
script.render = render

export default script